import React, { useState, useEffect } from 'react';
import './ColorModeToggle.scss';
import { FaMoon, FaSun } from 'react-icons/fa';
import { localDB } from '../../../../../../crud/localDB/localDB';

const ColorModeToggle: React.FC = () => {
  type Mode = 'light' | 'dark';
  // Local state for the toggle (default to light immediately to avoid FOUC)
  const [colorMode, setColorMode] = useState<Mode>('light');

  // On mount, load stored value from LocalDB
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const stored = await localDB.get<string>('ui', 'colorMode');
        if (mounted) {
          const normalized: Mode = stored === 'dark' ? 'dark' : 'light';
          setColorMode(normalized);
          document.documentElement.setAttribute('data-color-mode', normalized);
        }
      } catch {
        // Best-effort: keep default
        document.documentElement.setAttribute('data-color-mode', 'light');
      }
    })();
    return () => { mounted = false; };
  }, []);

  // Reflect changes to the document and persist
  useEffect(() => {
    document.documentElement.setAttribute('data-color-mode', colorMode);
    // Persist in LocalDB (fire and forget)
    void localDB.set('ui', 'colorMode', colorMode);
  }, [colorMode]);

  // Switch between dark and light modes
  const toggleColorMode = () => {
    setColorMode(prevMode => (prevMode === 'light' ? 'dark' : 'light'));
  };

  return (
    <label className="color-mode-toggle">
      <input
        type="checkbox"
        checked={colorMode === 'dark'}
        onChange={toggleColorMode}
      />
      <span className="slider">
        {/* Background icons for visual reference */}
        <FaSun className="icon sun" />
        <FaMoon className="icon moon" />
        {/* The moving knob that shows the current mode */}
        <span className="toggle-icon">
          {colorMode === 'dark' ? <FaMoon /> : <FaSun />}
        </span>
      </span>
    </label>
  );
};

export default ColorModeToggle;
